import React from 'react'
import PropTypes from 'prop-types'


const Radio = ({ onChange, name, object, value, label, children, readOnly = false }) => {
    const isChecked = object[name] === value
    const style = {
        display: 'inline-block',
    }
    return (
        <div style={style}>
            <input
                type="radio"
                className=""
                name={name}
                disabled={readOnly}
                value={value}
                checked={isChecked}
                onChange={event => {
                    onChange(name, event.target.value)
                }}
            />
            {children}
        </div>
    )
}

Radio.propTypes = {
    onChange: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    object: PropTypes.object.isRequired,
}


export default Radio



// WEBPACK FOOTER //
// ./src/modules/form/component/Radio.js